import { Box, Card, Flex, SimpleGrid, Stack } from "@mantine/core";
import { IStatbox } from "@mctypes/frontend.types";
import { IIssueItemStat } from "@mctypes/global.types";
import React from "react";
import TimeSum from "../../../../../components/TimeSum/TimeSum";
import { useAppSelector } from "../../../../../hooks";
import { selectIssueItemStat } from "../../issueStatsSelectors";
import { StatsBox } from "../../StatsBox";
import { StatusCircleChart } from "./StatusCircleChart";

const IssueStandardDashboard: React.FC = () => {
  const issueStats = useAppSelector(selectIssueItemStat);

  return (
    <Box h="100%" pos="relative" style={{ overflowX: "auto" }} w="100%">
      <StatsCard issueItemStat={issueStats} />
    </Box>
  );
};

export default IssueStandardDashboard;

const StatsCard: React.FC<{ issueItemStat: IIssueItemStat }> = ({ issueItemStat }) => {
  const boxes: IStatbox[] = [
    {
      icon: "fa-book",
      value: issueItemStat.count,
      text: `Registrert`,
      classColor: "icon-primary",
    },
    {
      icon: "fa-folder-open",
      value: issueItemStat.isOpen,
      text: `Åpne`,
      classColor: "icon-primary",
    },
    {
      icon: "fa-plus",
      value: issueItemStat.createdLast14Days,
      text: `Opprettet siste 14 dager`,
      classColor: "icon-info",
    },
    {
      icon: "fa-check",
      value: issueItemStat.completedLast14Days,
      text: `Lukket siste 14 dager`,
      classColor: "icon-success",
    },
    {
      icon: "fa-calendar",
      value: issueItemStat.dueNext14Days,
      text: `Tidsfrist neste 14 dager`,
      classColor: "icon-danger",
    },
  ];

  return (
    <Card withBorder radius="md" shadow="xs" mx="xs" p="md" style={{ backgroundColor: "var(--mantine-color-gray-0)" }}>
      <Stack gap="md">
        <SimpleGrid cols={{ base: 1, sm: 2, lg: boxes.length }} spacing="md">
          {boxes.map((stat, index) => (
            <StatsBox key={index} stat={stat} />
          ))}
        </SimpleGrid>
        <Flex align="stretch" gap="md" wrap="wrap">
          <Box w={320} flex="0 0 320px">
            <TimeSum sumHours={issueItemStat.hours} />
          </Box>
          <Card withBorder radius="md" shadow="xs" p="md" style={{ flex: "1 1 420px" }}>
            <StatusCircleChart />
          </Card>
        </Flex>
        {/* {issueItemStat.trend != null && (
          <>
            <VSpace />
            <Card mt="sm" style={{ width: "100%" }}>
              <CardBody>
                <TrendChart issueTrend={R.clone(issueItemStat.trend)} />
              </CardBody>
            </Card>
          </>
        )} */}
      </Stack>
    </Card>
  );
};
